__turbopack_context__.v({
  "className": "geist_mono_eb58308d-module__w_p2Lq__className",
  "variable": "geist_mono_eb58308d-module__w_p2Lq__variable",
});
